<div class="w-full">
    <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
      <h6 mat-dialog-title class="font-semibold primary-font">{{data?.data?.dialogTitle}}</h6>
    </div>
    <div class="flex flex-col">
        <form [formGroup]="RemarksForm" (ngSubmit)="submit()" class="cancelForm h-full overflow-y-none" autocomplete="off">
              <!-- CANCEL INVOICE -->
              <div class="w-full form-questions-height p-6 py-3">
                <mat-form-field appearance="fill" class="use-default-mat-height" ngClass="w-full" [hideRequiredMarker]="true" [floatLabel]="'always'">
                  <mat-label class="required primary-font font-semibold">{{'text.Reason' | translate}}</mat-label>
                    <textarea
                        matInput class="min-h-20"
                        id="reason" formControlName="reason"
                        placeholder="{{'invoice.details.update_status_dialog.cancel.reason.placeholder' | translate}}"
                        [rows]="5"
                        [spellcheck]="false"
                        matTextareaAutosize required></textarea>
                        <mat-error class="primary-font font-semibold text-base" *ngIf="RemarksForm.controls['reason']?.invalid">
                          {{'invoice.details.update_status_dialog.cancel.reason_is_required' | translate}}
                        </mat-error>
                </mat-form-field>
              </div>
              <div mat-dialog-actions class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
                <div class="flex justify-around space-x-2">
                    <button type="button" mat-stroked-button mat-dialog-close class="px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none btn-small">{{'close.text' | translate}}</button>
                    <button type="submit" [disabled]="showButtonSpinner" class="min-w-24 px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white text-base font-medium rounded-md focus:outline-none btn-small" [ngClass]="data?.data?.buttonColor">
                      <span *ngIf="!(showButtonSpinner && RemarksForm.valid)">{{data?.data?.buttonName | translate}}</span>
                      <mat-progress-spinner
                      *ngIf="showButtonSpinner && RemarksForm.valid"
                      [diameter]="24"
                      [mode]="'indeterminate'"></mat-progress-spinner>
                    </button>
                </div>
              </div>
        </form>
    </div>
</div> 